import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { UserAPIModel } from 'src/app/models/api.model'
import { AuthService } from 'src/app/services/common/auth.service'
import { getUserNameFromState } from 'src/app/store/selector/initialize.selector'
import { AppState } from 'src/app/store/state/app.state'

@Component({
  selector: 'app-greeting',
  templateUrl: './greeting.component.html',
  styleUrls: ['./greeting.component.scss']
})
export class GreetingComponent implements OnInit {
  userName$: Observable<string>

  constructor(private appState: Store<AppState>) {}

  ngOnInit(): void {
    this.userName$ = this.appState.select(getUserNameFromState)
  }
}
